module.exports = __webpack_public_path__ + "static/img/company_bg.7fc5044.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company_bg.png
// module id = LCD3
// module chunks = 1